import React from 'react'
import PropTypes from 'prop-types'
import Content from '../elements/Content'
import Inner from '../elements/Inner'
import { UpDown, UpDownWide } from '../styles/animations'
import { colors } from '../../tailwind'
import SVG from '../components/SVG'

const Projects = ({ children, offset }) => (
  <>
    
    <Content speed={0.4} offset={`${offset}.1`} factor={1}>
      <Inner>{children}</Inner>
    </Content>

  </>
)

export default Projects

Projects.propTypes = {
  children: PropTypes.node.isRequired,
  offset: PropTypes.number.isRequired,
}
